import React from 'react';
import { Button } from '../../../components/base/Button';

export const HeroSection: React.FC = () => {
  return (
    <section 
      id="home" 
      className="relative min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-100 via-white to-orange-100"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left side - Content */}
          <div className="text-left">
            <h1 className="text-4xl md:text-6xl font-bold mb-6 text-gray-900">
              <strong>Voda, Topení, Plyn 
Spolehlivě v Mladé Boleslavi</strong>
            </h1>
            <h2 className="text-xl md:text-2xl mb-8 text-gray-700">
              <strong>havárie, montáže kotlů i kompletní rekonstrukce. Rychlý příjezd a férové jednání.</strong>
            </h2>
            <div className="flex flex-col sm:flex-row gap-4">
              <Button href="tel:+420720520035" variant="primary" size="lg">
                <i className="ri-phone-line mr-2"></i>
                Zavolat nyní
              </Button>
              <a 
                href="#kontakt" 
                className="inline-flex items-center justify-center font-medium rounded-lg transition-colors cursor-pointer whitespace-nowrap border-2 border-blue-600 text-blue-600 hover:bg-blue-600 hover:text-white px-8 py-4 text-lg"
              >
                <i className="ri-mail-line mr-2"></i>
                Kontaktní formulář
              </a>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-12">
              <div className="bg-white rounded-lg p-6 shadow-md">
                <div className="w-12 h-12 bg-blue-600 rounded-lg flex items-center justify-center mb-4">
                  <i className="ri-tools-line text-white text-xl"></i>
                </div>
                <h3 className="text-lg font-semibold mb-2 text-gray-900">Instalatérské práce</h3>
                <p className="text-gray-600 text-sm">Kompletní instalace a opravy vodovodních systémů</p>
              </div>
              <div className="bg-white rounded-lg p-6 shadow-md">
                <div className="w-12 h-12 bg-red-600 rounded-lg flex items-center justify-center mb-4">
                  <i className="ri-fire-line text-white text-xl"></i>
                </div>
                <h3 className="text-lg font-semibold mb-2 text-gray-900">Topenářské práce</h3>
                <p className="text-gray-600 text-sm">Instalace a servis topných systémů</p>
              </div>
              <div className="bg-white rounded-lg p-6 shadow-md">
                <div className="w-12 h-12 bg-orange-600 rounded-lg flex items-center justify-center mb-4">
                  <i className="ri-24-hours-line text-white text-xl"></i>
                </div>
                <h3 className="text-lg font-semibold mb-2 text-gray-900">Havarijní opravy</h3>
                <p className="text-gray-600 text-sm">Rychlá pomoc 24 hodin denně</p>
              </div>
            </div>
          </div>

          {/* Right side - Logo */}
          <div className="flex items-center justify-center">
            <img 
              src="https://static.readdy.ai/image/cd36f9883938bafd66620af1a497dfc4/922a6cc1bcbe4a849c9d8b3340221f4a.png" 
              alt="TopInstal Snajdr Logo" 
              className="max-w-full w-full h-auto object-contain"
            />
          </div>
        </div>
      </div>
    </section>
  );
};
